import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { selectUserInfo } from "../auth.ducks";
import history from "../../../history";
import { UserI } from "../../../typings/interfaces";
import { PageRoute, UserRole } from "../../../models";
import { clearAdData, getAdData, selectAdData } from "../../AdForm/adForm.ducks";

export interface UserRequiredAdOwnershipProps {
  history?: History;
  location?: Location;
  match?: {
    path: string;
    url: string;
    isExact: boolean;
    params: {
      id: string;
    }
  };
  staticContext?: any;
  module: string;
  user: UserI | null;
  adData: any;
  getAdData: (adId: string, showErrorOnFetch: Function | null, callback: Function, allowNotFound?: boolean) => void;
}

interface RequireUserAdOwnershipOptions {
  // When true, admin/superAdmin can access the page even if the ad fetch returns 404.
  // Useful for the statistics page where admins may want to inspect deleted ads.
  adminBypassNotFound?: boolean;
}

export default (Com: Function, options: RequireUserAdOwnershipOptions = {}) => {
  const UserRequiredAdOwnershipComponent = (props: UserRequiredAdOwnershipProps) => {
    const {
      adData,
      user,
      getAdData,
      match: {
        params: { id }
      },
    } = props;

    const [hasOwership, setHasOwnership] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const isAdmin = !!user && (user.role === UserRole.superAdmin || user.role === UserRole.admin);
    const adminBypass = options.adminBypassNotFound && isAdmin;

    useEffect(() => {
      getAdData(id, null, (success) => {
        if (success || adminBypass) {
          setIsLoading(false);
        }
      }, adminBypass);

      return () => {
        clearAdData();
      };

    }, []);

    useEffect(() => {
      if (!user) return;

      // Check if user is super admin or admin
      if (user.role === UserRole.superAdmin || user.role === UserRole.admin) {
        if (adminBypass || adData) {
          setHasOwnership(true);
        }
        return;
      }

      if (!adData) return;

      if(adData.creatorId && adData.creatorId !== user.userId) {
        history.replace(PageRoute.myAd);
      }

      if (adData.creatorId && adData.creatorId === user.userId) {
        setHasOwnership(true);
      }
    }, [adData, user]);

    return hasOwership && !isLoading ? <Com {...props}  /> : null;
  };

  return connect(
    state => ({
      user: selectUserInfo(state),
      adData: selectAdData(state),
    }),
    {
      getAdData,
      clearAdData,
    }
  )(UserRequiredAdOwnershipComponent);
};



// WEBPACK FOOTER //
// ./src/routes/Auth/HOCs/requireUserAdOwnership.tsx